/**************************************************
 * Nombre:       Formulario_Producto_Informacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Producto_Informacion_Tab from "./Formulario_Producto_Informacion_Tab";
import Tarjetas_Producto_Tab from "../../Tarjeta/Tarjetas_Producto_Tab";
import IngresoTextoLista from "../../../Modulo_formularios/Componentes/IngresoTextoLista";
import {ShortTextOutlined} from '@mui/icons-material'

const Formulario_Producto_Informacion = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Agregar Informacion',
        dato: 'informaciones',
        Formulario: Formulario_Producto_Informacion_Tab,
        Tarjeta: Tarjetas_Producto_Tab
    })


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Nombre del producto'}
                                  dato={'nombre'} {...props}
                                  editable={false}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Informacion Adicional</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Producto_Informacion